import type { TRuleWithTheme } from '@/styles/theme';

export const label: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
});
